var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#743FAC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1621 21.586L18.8381 25.255V17.899L25.1621 21.586Z",
    fill: "#743FAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.461 13H14.539C13.9427 13 13.3522 13.1175 12.8013 13.3458C12.2504 13.5741 11.7499 13.9087 11.3284 14.3305C10.9069 14.7523 10.5726 15.253 10.3447 15.8041C10.1167 16.3551 9.99961 16.9457 10 17.542V25.612C9.99961 26.2083 10.1167 26.7989 10.3447 27.3499C10.5726 27.901 10.9069 28.4017 11.3284 28.8235C11.7499 29.2453 12.2504 29.5799 12.8013 29.8082C13.3522 30.0365 13.9427 30.154 14.539 30.154H29.461C30.0573 30.154 30.6478 30.0365 31.1987 29.8082C31.7496 29.5799 32.2501 29.2453 32.6716 28.8235C33.0931 28.4017 33.4274 27.901 33.6553 27.3499C33.8833 26.7989 34.0004 26.2083 34 25.612V17.542C34.0004 16.9457 33.8833 16.3551 33.6553 15.8041C33.4274 15.253 33.0931 14.7523 32.6716 14.3305C32.2501 13.9087 31.7496 13.5741 31.1987 13.3458C30.6478 13.1175 30.0573 13 29.461 13ZM18.838 25.255V17.899L25.162 21.577L18.838 25.255Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1b83ec0ee9cc3d0d19396fe001da4a5e.svg";
export { ForwardRef as ReactComponent };